import { PassengersSeatMap } from '@seat-map/entities/seat-map';
import { Component, ViewEncapsulation, ChangeDetectionStrategy, Output, EventEmitter, Input } from '@angular/core';

import { SeatMapFacade } from '@seat-map/seat-map.facade';
import { ItineraryDetail, AirValidationFlightsSector } from '@seat-map/entities/itinerary-detail';

@Component({
  selector: 'app-select-sector-mobile',
  templateUrl: './select-sector-mobile.component.html',
  styleUrls: ['./select-sector-mobile.component.sass'],
  encapsulation: ViewEncapsulation.ShadowDom,
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false
})
export class SelectSectorMobileComponent {

  @Input() itineraryDetail: ItineraryDetail;

  @Output() selectSector: EventEmitter<void> = new EventEmitter<void>();

  constructor(
    private readonly facade: SeatMapFacade
  ) { }

  public flightItemGroupId(flightItem: AirValidationFlightsSector): string {
    return `${flightItem.DepartureAirport}-${flightItem.ArrivalAirport}`;
  }

  public selectSelectorItinerary(itineraryDetail: ItineraryDetail, sector: number): void {
    this.facade.selectSectorItineraryDetail(sector);
    this.facade.fetchSeatMapFlight(
      itineraryDetail.Id, itineraryDetail.AirReservationId,
      this.getFlightIx(itineraryDetail, sector), itineraryDetail.Passengers as PassengersSeatMap[]);
    this.selectSector.emit();
  }

  private getFlightIx(itineraryDetail: ItineraryDetail, sectorNumber: number): number {
    let countFlighs = 0;
    for (const _sector of itineraryDetail.Sectors) {
      if (_sector.SectorNumber === sectorNumber) {
        countFlighs = countFlighs > 0 ? countFlighs + 1 : countFlighs;
        break;
      }
      countFlighs += _sector.Flights.length - 1;
    }
    return countFlighs;
  }
}
